module.exports = __webpack_public_path__ + "static/media/bukak.9ea6da8d.jpg";